module.exports = __webpack_public_path__ + "media/chl/favicon-c44f4b92.ico";